function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M128 135.6c13.5 0 19.8 10.3 21 24.6.4 3.4 0 8.5-.4 14.3-1.4 19.4-3.2 43.4 9.7 43.4 10.9 0 16.6-21 19.8-45.1 3.2-23.8-.2-35.6 1.4-46 3-20 20.6-37.8 15.1-63.4-3-14.1-10.7-20.8-18.3-23.6-17.8-6.5-29.3 6-48.3 6s-30.5-12.5-48.3-6c-7.7 2.9-15.5 9.5-18.3 23.6-5.5 25.4 12.1 43.4 15.1 63.4 1.6 10.5-1.6 22.4 1.4 46 3.2 24 8.9 45.1 19.8 45.1 12.9 0 11.3-23.8 9.7-43.4-.4-5.8-.8-10.9-.4-14.3 1.2-14.5 7.6-24.6 21-24.6z"
});

var SvgIconDental = function SvgIconDental(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgIconDental;